import { Redirect } from "react-router-dom"
import { useAuthenticated } from "providers/A12n"

export function Landing() {
  const { hasAuthority } = useAuthenticated()
  const hasAccessGlobal = hasAuthority(["AUTH_ACCESS_GLOBAL_ADMIN"])
  const hasAccessFinance = hasAuthority(["AUTH_ACCESS_GLOBAL_FINANCE"])
  const hasAccessPlan = hasAuthority(["AUTH_VIEW_PLANNING_DASHBOARD"])
  const hasAccessRegional = hasAuthority(["AUTH_ACCESS_REGION_FINANCE"])
  const hasAccessAgency = hasAuthority([
    "AUTH_ACCESS_AGENCY_ADMIN",
    "AUTH_ACCESS_AGENCY_FINANCE",
  ])
  const hasAccessMarket = hasAuthority([
    "AUTH_ACCESS_MARKET_ADMIN",
    "AUTH_ACCESS_MARKET_FINANCE",
  ])
  const hasBoookingAccess = hasAuthority(["AUTH_ACCESS_BUYER"])
  const hasBillingAccess = hasAuthority(["AUTH_ACCESS_BILLER"])
  const hasSupportAccess = hasAuthority(["AUTH_ACCESS_SUPPORT"])

  let landing = "/plans"

  if (hasAccessPlan) landing = "/plans"
  if (hasAccessRegional) landing = "/revenue"
  if (hasAccessGlobal) landing = "/admin-regions/APAC"
  if (hasAccessFinance) landing = "/revenue"
  if (hasAccessMarket) landing = "/market-settings"
  if (hasAccessAgency) landing = "/agency-companies"
  if (hasBoookingAccess) landing = "/booking-orders"
  if (hasBillingAccess) landing = "/invoices"
  if (hasSupportAccess) landing = "/support/market-initialization"

  return <Redirect to={landing} />
}
